import { QUES_COMPONENT_TYPES } from '../componentTypes';

const levelOptions = [{ text: 'Low' }, { text: 'Medium' }, { text: 'High' }];

export default [
  {
    sequenceNumber: 11,
    content:
      'What is the intended level of integration across the following functions?',
    subSection: 'TODO subSection',
    type: QUES_COMPONENT_TYPES.MULTIRADIO,
    options: [
      {
        section: 'Go to Market',
        options: levelOptions,
      },
      {
        section: 'Business Processes and Systems',
        options: levelOptions,
      },
      {
        section: 'People',
        options: levelOptions,
      },
      {
        section: 'Operations',
        options: levelOptions,
      },
      {
        section: 'Legal Entities and Facilities',
        options: levelOptions,
      },
    ],
  },
  {
    sequenceNumber: 12,
    subTitle: 'TODO subTitle',
    content:
      'How experienced and mature is your organization with M&A Capabilities (e.g, established IMO, integration playbooks, cross-functional teams, etc)',
    subSection: 'TODO subSection',
    type: QUES_COMPONENT_TYPES.RADIO,
    options: [
      { text: 'We have very little M&A experience' },
      {
        text: 'We have completed a few transactions but have a long way to go',
      },
      { text: "We have some experience, but there's room to grow" },
      {
        text: 'We are experienced and have well-defined playbooks, but can always improve',
      },
      { text: 'We are a well-oiled machine' },
    ],
    compLocation: 'left',
  },
  {
    sequenceNumber: 13,
    subTitle: 'TODO subTitle',
    content:
      'What level of organizational commitment and resourcing do you have for this deal?',
    subSection: 'TODO subSection',
    type: QUES_COMPONENT_TYPES.RADIO,
    options: [
      {
        text: 'This is a low priority and will mostly be staffed by resources with other primary responsibilities',
      },
      {
        text: 'This is a mid-level priority and will be staffed by resources with other primary responsibilities',
      },
      {
        text: 'This is a mid-level priority and will be staffed by a combination of dedicated resources and resources with other primary responsibilities',
      },
      {
        text: 'This is a high priority and will be staffed by a dedicated M&A Integration team',
      },
      {
        text: 'This is a top priority to leadership and will be staffed by a dedicated M&A Integration team',
      },
    ],
    compLocation: 'left',
  },
];
